module.exports = __webpack_public_path__ + "static/media/nip-main.3ae6a5c3.svg";